import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

// Vue.directive('date', {
//     bind: function (el) {
//         let myDate = new Date();
//         let data = myDate.toLocaleDateString().split(2019).join(19);
//         let time = myDate.toLocaleTimeString().slice(0, 5);
//         el.innerHTML = `${data}    ${time}`;
//     }
// });


new Vue({
    render: h => h(App),
    mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app');
